import React, { Component, Fragment } from "react";
import { LoggedUserContext } from "../LoggedUserContext";

import { acquireToken } from "../adalConfig";

import EditIcon from "@material-ui/icons/Edit";
import {
  Button,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogTitle,
  Grid,
  Tooltip,
  IconButton,
} from "@material-ui/core/";
import Axios from "axios";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

export default class EmailsAccountsUpdateForm extends Component {
  account = {
    emailAccountId: 0,
    emailAccountName: "",
    emailAccountEmail: "",
    emailAccountPassword: "",
    emailAccountStatus: true,
    emailAccountCreateDate: new Date(),
    emailAccountLastUpdateDate: new Date(),
    emailAccountUserModifiedId: this.context.userId,
  };
  currentUser = this.context;
  state = {
    open: false,
    js: {
      emailAccount: this.account,
      user: this.currentUser,
    },

    NameError: "",
    EmailError: "",
  };

  componentDidMount() {
    const id = this.props.id;
    const url = `${process.env.REACT_APP_API_URL}/EmailAccountAPI/GetEmailAccountPerId/${id}`;

    acquireToken().then((token) => {
      Axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((res) => {
          if (res.data.code === 0) {
            const items = res.data.items;
            if (items[0]){
              this.account = items[0];
              this.account.emailAccountPassword = "";
            }
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the email account",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the email account",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });
    });
  }

  handleSubmit = (event) => {
    if (this.ValidateAccount()) {
      event.preventDefault();
      const preState = { ...this.state.js };

      acquireToken().then((token) => {
        const url = `${process.env.REACT_APP_API_URL}/EmailAccountAPI/UpdateEmailAccount`;
        Axios.post(url, preState, {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
          .then((res) => {
            if (res.data.code === 0) {
              MySwal.fire({
                icon: "success",
                title: "The email account was updated successfully",
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              }).then(() => {
                window.location.reload();
              });
            } else {
              MySwal.fire({
                icon: "error",
                title: "An error has occurred while updating the email account",
                //text: res.data.description,
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              });
            }
          })
          .catch((error) => {
            if (error.toString().includes("status code 403")) {
              window.location.href = "/NoAuth";
            } else {
              MySwal.fire({
                icon: "error",
                title: "An error has occurred while updating the email account",
                //text: error,
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              });
            }
          });
      });
    }
  };

  handleToggle = () => {
    this.setState({
      open: !this.state.open,
      js: {
        emailAccount: this.account,
        user: this.currentUser,
      },
    });
  };

  handlechange = (name) => ({ target: { value } }) => {
    this.setState({
      js: {
        emailAccount: {
          ...this.state.js.emailAccount,
          [name]: value,
        },
        user: this.currentUser,
      },
    });
  };

  render() {
    const {
      open,
      js: {
        emailAccount: {
          emailAccountName,
          emailAccountEmail,
          //emailAccountPassword,
        },
      },
    } = this.state;

    return (
      <Fragment>
        <Tooltip title="Edit">
          <IconButton
            onClick={this.handleToggle}
            style={{ backgroundColor: "#797991" }}
            aria-label="edit"
          >
            <EditIcon />
          </IconButton>
        </Tooltip>

        <Dialog open={open} onClose={this.handleToggle} style={{ zIndex: 100 }}>
          <DialogTitle id="form-dialog-title">Update Email Account</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please fill out the form below
            </DialogContentText>
            <form>
              <Grid container spacing={2}>
                <Grid item>
                  <TextField
                    required
                    label="Display Name"
                    value={emailAccountName}
                    onChange={this.handlechange("emailAccountName")}
                    margin="normal"
                  />
                  <div style={{ color: "red" }}>{this.state.NameError}</div>
                </Grid>
                <Grid item>
                  <TextField
                    required
                    label="Email Address"
                    value={emailAccountEmail}
                    onChange={this.handlechange("emailAccountEmail")}
                    margin="normal"
                  />
                  <div style={{ color: "red" }}>{this.state.EmailError}</div>
                </Grid>
                {/* <Grid item>
                  <TextField
                    label="Email Password"
                    value={emailAccountPassword}
                    type="password"
                    onChange={this.handlechange("emailAccountPassword")}
                    margin="normal"
                  />
                </Grid> */}
              </Grid>
              <Button type="button" color="primary" onClick={this.handleSubmit}>
                Update Account
              </Button>
            </form>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </Fragment>
    );
  }

  ValidateAccount = () => {
    let valid = true;
    if (
      this.state.js.emailAccount.emailAccountName === "" ||
      this.state.js.emailAccount.emailAccountName === undefined
    ) {
      this.setState({ NameError: "This field is required" });
      valid = false;
    } else if (this.state.js.emailAccount.emailAccountName.length > 40) {
      this.setState({
        NameError: "The maximum number of characters allowed is 40",
      });
      valid = false;
    } else if (
      // eslint-disable-next-line
      /^[A-Za-z0-9,\.\-_\(\)!\?\/: ]*$/.test(
        this.state.js.emailAccount.emailAccountName
      ) === false
    ) {
      this.setState({ NameError: "The field contains invalid characters" });
      valid = false;
    } else {
      this.setState({ NameError: "" });
    }

    if (
      this.state.js.emailAccount.emailAccountEmail === "" ||
      this.state.js.emailAccount.emailAccountEmail === undefined
    ) {
      this.setState({ EmailError: "This field is required" });
      valid = false;
    } else if (
      // eslint-disable-next-line
      /^([a-zA-Z0-9_\-\.]+)@(([a-zA-Z0-9_\-\.]+)\.)*(ey\.)(com|net)+$/.test(
        this.state.js.emailAccount.emailAccountEmail
      ) === false
    ) {
      this.setState({
        EmailError: "The email format is invalid or is not an ey account",
      });
      valid = false;
    } else {
      this.setState({ EmailError: "" });
    }

    return valid;
  };
}

EmailsAccountsUpdateForm.contextType = LoggedUserContext;
